if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) {
          // Form not present in this instance — abort initialization to avoid errors.
          return;
        }
        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

//       onSubmitHandler(evt) {
//         evt.preventDefault();
//         if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//         this.handleErrorMessage();

//         this.submitButton.setAttribute('aria-disabled', true);
//         this.submitButton.classList.add('loading');
//         this.querySelector('.loading__spinner').classList.remove('hidden');

//         const config = fetchConfig('javascript');
//         config.headers['X-Requested-With'] = 'XMLHttpRequest';
//         delete config.headers['Content-Type'];

//         const formData = new FormData(this.form);
//         if (this.cart) {
//           formData.append(
//             'sections',
//             this.cart.getSectionsToRender().map((section) => section.id)
//           );
//           formData.append('sections_url', window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }

//        // Remove trailing comma and square brackets
// const trimmedString = formData.get('id').replace(/\[|\]$/g, '');

// // Split by comma to get an array of IDs as strings
// const idArray = trimmedString.split(',');
// console.log(idArray)

// const idNumbers = idArray.map(id => {
//   const num = parseInt(id.trim(),10); // Parse each ID and trim any leading/trailing whitespace
//   return isNaN(num) ? null : num; // Check if parsed value is NaN and return null if so
// }).filter(id => id !== null); // Filter out null values

// console.log(idNumbers); // This will output: [48644813914403, 48644814045475, 48644814176547, 48644814307619, 48644814438691]
// idNumbers.forEach(id => {
//             formData.set('id', id);
//   console.log(formData.get("id"));
            
//             config.body = formData;

//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((response) => {
//             if (response.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 errors: response.errors || response.description,
//                 message: response.message,
//               });
//               this.handleErrorMessage(response.description);

//               const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//               if (!soldOutMessage) return;
//               this.submitButton.setAttribute('aria-disabled', true);
//               this.submitButton.querySelector('span').classList.add('hidden');
//               soldOutMessage.classList.remove('hidden');
//               this.error = true;
//               return;
//             } 
//             // else if (!this.cart) {
//             //   window.location = window.routes.cart_url;
//             //   return;
//             // }

//             if (!this.error)
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 cartData: response,
//               });
//             this.error = false;
//             const quickAddModal = this.closest('quick-add-modal');
//             if (quickAddModal) {
//               document.body.addEventListener(
//                 'modalClosed',
//                 () => {
//                   setTimeout(() => {
//                     this.cart.renderContents(response);
//                   });
//                 },
//                 { once: true }
//               );
//               quickAddModal.hide(true);
//             }
//             //  else {
//             //   this.cart.renderContents(response);
//             // }
//           })
//           .catch((e) => {
//             console.error(e);
//           })
//           .finally(() => {
//             this.submitButton.classList.remove('loading');
//             if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//             if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//             this.querySelector('.loading__spinner').classList.add('hidden');
//           });
//     //         formData.forEach((value, key) => {
//     // //           if (key.startsWith('quantity')) {
//     // //             if (value !== "0") {
//     // //               console.log(`${key}: ${value}`);
//     // //               indexToRemove++;
//     // //             }else{
//     // // console.log(indexToRemove);
//     // //  idNumbers.splice(indexToRemove, 1);
//     // //             }
                
//     // //           } else {
//     //             console.log(`${key}: ${value}`);
//               // }
//             });
// // formData.set('id',idNumbers[0])
          
//       }
// onSubmitHandler(evt) {
//   evt.preventDefault();
//   console.log('Form submission prevented.');

//   if (this.submitButton.getAttribute('aria-disabled') === 'true') {
//     console.log('Submit button is disabled.');
//     return;
//   }

//   console.log('Handling error messages.');
//   this.handleErrorMessage();

//   console.log('Disabling submit button and showing loading spinner.');
//   this.submitButton.setAttribute('aria-disabled', true);
//   this.submitButton.classList.add('loading');
//   this.querySelector('.loading__spinner').classList.remove('hidden');

//   const config = fetchConfig('javascript');
//   config.headers['X-Requested-With'] = 'XMLHttpRequest';
//   delete config.headers['Content-Type'];
//   console.log('Fetch configuration set:', config);

//   const formData = new FormData(this.form);
//   console.log('FormData created:', Array.from(formData.entries()));

//   if (this.cart) {
//     formData.append(
//       'sections',
//       this.cart.getSectionsToRender().map((section) => section.id)
//     );
//     formData.append('sections_url', window.location.pathname);
//     this.cart.setActiveElement(document.activeElement);
//     console.log('Cart sections and URL added to FormData:', Array.from(formData.entries()));
//   }

//   const trimmedString = formData.get('id').replace(/\[|\]$/g, '');
//   const idArray = trimmedString.split(',');
//   const idNumbers = idArray.map(id => {
//     const num = parseInt(id.trim(), 10);
//     return isNaN(num) ? null : num;
//   }).filter(id => id !== null);
//   console.log('Parsed ID numbers:', idNumbers);

//   const quantityValues = [];
//   let indexToRemove = 0;

//   formData.forEach((value, key) => {
//     if (key.startsWith('quantity')) {
//       if (value !== "0") {
//         quantityValues.push(value);
//         indexToRemove++;
//       } else {
//         idNumbers.splice(indexToRemove, 1);
//       }
//     }
//   });
//   console.log('Quantity values:', quantityValues);
//   console.log('Updated ID numbers after removing zero quantities:', idNumbers);

//   const processIds = async () => {
//     for (let i = 0; i < idNumbers.length; i++) {
//       const id = idNumbers[i];
//       const quantity = quantityValues[i];

//       formData.set('id', id);
//       formData.set('quantity', quantity);
//       console.log(`Processing ID: ${id}, Quantity: ${quantity}`);
//       console.log('Updated FormData:', Array.from(formData.entries()));

//       config.body = formData;

//       try {
//         const response = await fetch(`${routes.cart_add_url}`, config).then(res => res.json());
//         console.log('Response received:', response);

//         if (response.status) {
//           console.log('Error in response:', response);
//           publish(PUB_SUB_EVENTS.cartError, {
//             source: 'product-form',
//             productVariantId: formData.get('id'),
//             errors: response.errors || response.description,
//             message: response.message,
//           });
//           this.handleErrorMessage(response.description);

//           const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//           if (!soldOutMessage) return;
//           this.submitButton.setAttribute('aria-disabled', true);
//           this.submitButton.querySelector('span').classList.add('hidden');
//           soldOutMessage.classList.remove('hidden');
//           this.error = true;
//           return;
//         }

//         if (!this.error) {
//           console.log('Publishing cart update.');
//           publish(PUB_SUB_EVENTS.cartUpdate, {
//             source: 'product-form',
//             productVariantId: formData.get('id'),
//             cartData: response,
//           });
//         }

//         this.error = false;

//         const quickAddModal = this.closest('quick-add-modal');
//         if (quickAddModal) {
//           document.body.addEventListener(
//             'modalClosed',
//             () => {
//               setTimeout(() => {
//                 this.cart.renderContents(response);
//               });
//             },
//             { once: true }
//           );
//           quickAddModal.hide(true);
//         } else if (i === idNumbers.length - 1 && !this.cart) {
//           console.log('Redirecting to cart URL.');
//           window.location = window.routes.cart_url;
//           return;
//         }

//       } catch (e) {
//         console.error('Error during fetch:', e);
//       } finally {
//         if (i === idNumbers.length - 1) {
//           console.log('Finalizing: removing loading state and handling errors.');
//           this.submitButton.classList.remove('loading');
//           if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//           if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading__spinner').classList.add('hidden');
//         }
//       }
//     }
//   };

//   console.log('Starting ID processing.');
//   processIds();
// }
// onSubmitHandler(evt) {
//   evt.preventDefault();
//   console.log('Form submission prevented.');

//   if (this.submitButton.getAttribute('aria-disabled') === 'true') {
//     console.log('Submit button is disabled.');
//     return;
//   }

//   console.log('Handling error messages.');
//   this.handleErrorMessage();

//   console.log('Disabling submit button and showing loading spinner.');
//   this.submitButton.setAttribute('aria-disabled', true);
//   this.submitButton.classList.add('loading');
//   this.querySelector('.loading__spinner').classList.remove('hidden');

//   const config = fetchConfig('javascript');
//   config.headers['X-Requested-With'] = 'XMLHttpRequest';
//   delete config.headers['Content-Type'];
//   console.log('Fetch configuration set:', config);

//   const formData = new FormData(this.form);
//   console.log('FormData created:', Array.from(formData.entries()));

//   if (this.cart) {
//     formData.append(
//       'sections',
//       this.cart.getSectionsToRender().map((section) => section.id)
//     );
//     formData.append('sections_url', window.location.pathname);
//     this.cart.setActiveElement(document.activeElement);
//     console.log('Cart sections and URL added to FormData:', Array.from(formData.entries()));
//   }

//   const trimmedString = formData.get('id').replace(/\[|\]$/g, '');
//   const idArray = trimmedString.split(',');
//   const idNumbers = idArray.map(id => {
//     const num = parseInt(id.trim(), 10);
//     return isNaN(num) ? null : num;
//   }).filter(id => id !== null);
//   console.log('Parsed ID numbers:', idNumbers);

//   const quantityValues = [];
//   let indexToRemove = 0;

//   formData.forEach((value, key) => {
//     if (key.startsWith('quantity')) {
//       if (value !== "0") {
//         quantityValues.push(value);
//         indexToRemove++;
//       } else {
//         idNumbers.splice(indexToRemove, 1);
//       }
//     }
//   });
//   console.log('Quantity values:', quantityValues);
//   console.log('Updated ID numbers after removing zero quantities:', idNumbers);

//   const processIds = async () => {
//     for (let i = 0; i < idNumbers.length; i++) {
//       const id = idNumbers[i];
//       const quantity = quantityValues[i];

//       const newFormData = new FormData(this.form);
//       newFormData.set('id', id);
//       newFormData.set('quantity', quantity);
//       console.log(`Processing ID: ${id}, Quantity: ${quantity}`);
//       console.log('Updated newFormData:', Array.from(newFormData.entries()));

//       config.body = newFormData;

//       try {
//         const response = await fetch(`${routes.cart_add_url}`, config).then(res => res.json());
//         console.log('Response received:', response);

//         if (response.status) {
//           console.log('Error in response:', response);
//           publish(PUB_SUB_EVENTS.cartError, {
//             source: 'product-form',
//             productVariantId: newFormData.get('id'),
//             errors: response.errors || response.description,
//             message: response.message,
//           });
//           this.handleErrorMessage(response.description);

//           const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//           if (!soldOutMessage) return;
//           this.submitButton.setAttribute('aria-disabled', true);
//           this.submitButton.querySelector('span').classList.add('hidden');
//           soldOutMessage.classList.remove('hidden');
//           this.error = true;
//           return;
//         }

//         if (!this.error) {
//           console.log('Publishing cart update.');
//           publish(PUB_SUB_EVENTS.cartUpdate, {
//             source: 'product-form',
//             productVariantId: newFormData.get('id'),
//             cartData: response,
//           });
//         }

//         this.error = false;

//         const quickAddModal = this.closest('quick-add-modal');
//         if (quickAddModal) {
//           document.body.addEventListener(
//             'modalClosed',
//             () => {
//               setTimeout(() => {
//                 this.cart.renderContents(response);
//               });
//             },
//             { once: true }
//           );
//           quickAddModal.hide(true);
//         } else if (i === idNumbers.length - 1 && !this.cart) {
//           console.log('Redirecting to cart URL.');
//           window.location = window.routes.cart_url;
//           return;
//         }

//       } catch (e) {
//         console.error('Error during fetch:', e);
//       } finally {
//         if (i === idNumbers.length - 1) {
//           console.log('Finalizing: removing loading state and handling errors.');
//           this.submitButton.classList.remove('loading');
//           if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//           if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading__spinner').classList.add('hidden');
//         }
//       }
//     }
//   };

//   console.log('Starting ID processing.');
//   processIds();
// }
onSubmitHandler(evt) {
  evt.preventDefault();
  console.log('Form submission prevented.');

  if (this.submitButton.getAttribute('aria-disabled') === 'true') {
    console.log('Submit button is disabled.');
    return;
  }

  console.log('Handling error messages.');
  this.handleErrorMessage();

  console.log('Disabling submit button and showing loading spinner.');
  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  console.log('Fetch configuration set:', config);

  const formData = new FormData(this.form);
  console.log('FormData created:', Array.from(formData.entries()));

  if (this.cart) {
    formData.append(
      'sections',
      this.cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
    console.log('Cart sections and URL added to FormData:', Array.from(formData.entries()));
  }

  let idToUse = formData.get('id') || '';
  const pId = formData.get('p_id') || '';
  if (pId.length > 0) {
    console.log("true");
    idToUse = pId;
  }

  const trimmedString = String(idToUse).replace(/\[|\]$/g, '');
  const idArray = trimmedString.split(',');
  const idNumbers = idArray.map(id => {
    const num = parseInt(id.trim(), 10);
    return isNaN(num) ? null : num;
  }).filter(id => id !== null);
  console.log('Parsed ID numbers:', idNumbers);

  const quantityValues = [];
  let indexToRemove = 0;

  formData.forEach((value, key) => {
    if (key.startsWith('quantity')) {
      if (value !== "0") {
        quantityValues.push(value);
        indexToRemove++;
      } else {
        idNumbers.splice(indexToRemove, 1);
      }
    }
  });
  console.log('Quantity values:', quantityValues);
  console.log('Updated ID numbers after removing zero quantities:', idNumbers);
  const totalQuantity = quantityValues.reduce((sum, currentValue) => sum + Number(currentValue), 0);
console.log(totalQuantity);
const pIdCheck = formData.get('p_id') || '';
if (totalQuantity >= 10 || pIdCheck.length == 0 ) {
    // Proceed with your next steps
    console.log('Proceeding with next steps.');
      const processIds = async () => {
    for (let i = 0; i < idNumbers.length; i++) {
      const id = idNumbers[i];
      const quantity = quantityValues[i];

      const newFormData = new FormData(this.form);
      newFormData.set('id', id);
      newFormData.set('quantity', quantity);
      console.log(`Processing ID: ${id}, Quantity: ${quantity}`);
      console.log('Updated newFormData:', Array.from(newFormData.entries()));

      config.body = newFormData;

      try {
        const response = await fetch(`${routes.cart_add_url}`, config).then(res => res.json());
        console.log('Response received:', response);

        if (response.status) {
          console.log('Error in response:', response);
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: newFormData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        }

        if (!this.error) {
          
          console.log('Publishing cart update.');
          console.log("first image",formData.get('first_image'));
          console.log("second image",formData.get('second_image'));
if(formData.get('first_image')==="true"&&formData.get('second_image')==="true"){
  console.log("Both images are true");
  const newFormData1 = new FormData(this.form);
  newFormData1.set('id', 48880672047395);
  newFormData1.set('quantity', quantity);
//   try {
//     const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//             quantity: quantity,
//             product_id: "48880672047395"
//         })
//     });

//     const data = await response.json();
//     console.log('Response received:', data);
    
 
// } catch (error) {
//     console.error('Error adding to cart:', error);
// }
  config.body = newFormData1;
  const response = await fetch(`${routes.cart_add_url}`, config).then(res => res.json());
  console.log('Response received:', response);

}


          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: newFormData.get('id'),
            cartData: response,
          });
          
        }

        this.error = false;
// if(this.error)

        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else if (i === idNumbers.length - 1) {
          // If we have a cart drawer, render contents and open it
          if (this.cart && this.cart.renderContents) {
            this.cart.renderContents(response);
          } else if (!this.cart) {
            console.log('Redirecting to cart URL.');
            window.location = window.routes.cart_url;
            return;
          }
        }

      } catch (e) {
        console.error('Error during fetch:', e);
        this.error = true;
        this.handleErrorMessage('An error occurred while adding to cart. Please try again.');
      } finally {
        if (i === idNumbers.length - 1) {
          console.log('Finalizing: removing loading state and handling errors.');
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          } else {
            this.submitButton.setAttribute('aria-disabled', 'true');
          }
          const spinner = this.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
      }
    }
  };

  console.log('Starting ID processing.');
  processIds();

} else {
    // Show alert if the sum is not greater than 10
   
    console.log('Finalizing: removing loading state and handling errors.');
              this.submitButton.classList.remove('loading');
              this.submitButton.setAttribute('aria-disabled', false);
              this.querySelector('.loading__spinner').classList.add('hidden');
              alert('The total quantity must be greater than 10 to proceed.');
}

//   const processIds = async () => {
//     for (let i = 0; i < idNumbers.length; i++) {
//       const id = idNumbers[i];
//       const quantity = quantityValues[i];

//       const newFormData = new FormData(this.form);
//       newFormData.set('id', id);
//       newFormData.set('quantity', quantity);
//       console.log(`Processing ID: ${id}, Quantity: ${quantity}`);
//       console.log('Updated newFormData:', Array.from(newFormData.entries()));

//       config.body = newFormData;

//       try {
//         const response = await fetch(`${routes.cart_add_url}`, config).then(res => res.json());
//         console.log('Response received:', response);

//         if (response.status) {
//           console.log('Error in response:', response);
//           publish(PUB_SUB_EVENTS.cartError, {
//             source: 'product-form',
//             productVariantId: newFormData.get('id'),
//             errors: response.errors || response.description,
//             message: response.message,
//           });
//           this.handleErrorMessage(response.description);

//           const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//           if (!soldOutMessage) return;
//           this.submitButton.setAttribute('aria-disabled', true);
//           this.submitButton.querySelector('span').classList.add('hidden');
//           soldOutMessage.classList.remove('hidden');
//           this.error = true;
//           return;
//         }

//         if (!this.error) {
          
//           console.log('Publishing cart update.');
//           console.log("first image",formData.get('first_image'));
//           console.log("second image",formData.get('second_image'));
// if(formData.get('first_image')==="true"&&formData.get('second_image')==="true"){
//   console.log("Both images are true");
//   const newFormData1 = new FormData(this.form);
//   newFormData1.set('id', 48880672047395);
//   newFormData1.set('quantity', quantity);
// //   try {
// //     const response = await fetch('/cart/add.js', {
// //         method: 'POST',
// //         headers: {
// //             'Content-Type': 'application/json'
// //         },
// //         body: JSON.stringify({
// //             quantity: quantity,
// //             product_id: "48880672047395"
// //         })
// //     });

// //     const data = await response.json();
// //     console.log('Response received:', data);
    
 
// // } catch (error) {
// //     console.error('Error adding to cart:', error);
// // }
//   config.body = newFormData1;
//   const response = await fetch(`${routes.cart_add_url}`, config).then(res => res.json());
//   console.log('Response received:', response);

// }


//           publish(PUB_SUB_EVENTS.cartUpdate, {
//             source: 'product-form',
//             productVariantId: newFormData.get('id'),
//             cartData: response,
//           });
          
//         }

//         this.error = false;
// // if(this.error)

//         const quickAddModal = this.closest('quick-add-modal');
//         if (quickAddModal) {
//           document.body.addEventListener(
//             'modalClosed',
//             () => {
//               setTimeout(() => {
//                 this.cart.renderContents(response);
//               });
//             },
//             { once: true }
//           );
//           quickAddModal.hide(true);
//         } else if (i === idNumbers.length - 1 && !this.cart) {
//           console.log('Redirecting to cart URL.');
//           window.location = window.routes.cart_url;
//           return;
//         }

//       } catch (e) {
//         console.error('Error during fetch:', e);
//       } finally {
//         if (i === idNumbers.length - 1) {
//           console.log('Finalizing: removing loading state and handling errors.');
//           this.submitButton.classList.remove('loading');
//           if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//           if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading__spinner').classList.add('hidden');
//         }
//       }
//     }
//   };

//   console.log('Starting ID processing.');
//   processIds();
}



      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
